import { MouseEventHandler } from "react";

import downloadDark from "./download_icon2_16px_dark.png";
import downloadLight from "./download_icon2_16px_light.png";

type DownloadIconProps = {
  color?: "dark" | "light";
  handleDownloadButtonClicked?: MouseEventHandler<HTMLImageElement>;
};

const DOWNLOAD_IMAGES: Record<"dark" | "light", string> = {
  dark: downloadDark,
  light: downloadLight,
};

export const DownloadIcon2 = ({
  color = "dark",
  handleDownloadButtonClicked,
}: DownloadIconProps) => (
  <img
    src={DOWNLOAD_IMAGES[color] || DOWNLOAD_IMAGES["dark"]}
    alt="Download icon2"
    onClick={handleDownloadButtonClicked}
    style={{ cursor: "pointer" }}
  />
);
